import { ArrowBack, InfoOutlined } from "@mui/icons-material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import FilterListIcon from "@mui/icons-material/FilterList";
import GetAppIcon from "@mui/icons-material/GetApp";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SearchIcon from "@mui/icons-material/Search";
import UploadIcon from "@mui/icons-material/Upload";
import { Box, Card, Chip, CircularProgress, IconButton, Tab, Tabs, Tooltip, Typography } from "@mui/material";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { CustomButton } from "src/Components/Common/Button/CustomButton";
import { LoggedInSkeleton } from "src/Components/Common/LoggedInSkeleton";
import { getReconTopBarButtons } from "src/Components/Common/TopNavBar";
import { userContext } from "src/Components/Contexts/userContext";
import ReactTable from "src/Components/ReactTable/ReactTable";
import { formatMoney, ToDineroObj } from "src/Utils/MoneyUtils";
// import * as XLSX from "xlsx";
import LogoutIcon from "@mui/icons-material/Logout";
import { Buffer } from "buffer";
import saveAs from "file-saver";
import useFetch from "src/Components/Common/useFetch";
import { UserRole } from "src/entity/models/FrontendActor";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";
import { filterDateBetweenStartAndEndDate, formatDate } from "src/Utils/DateUtils";
import { InstamartInternalProcessRole } from "../RejectedInvoices/RejectedInvoices";
import RejectedInvoicesFiltersBars from "../RejectedInvoices/RejectedInvoicesFiltersBars";
import BulkActionDisputedEntries from "./BulkActionDisputedEntries";
import { DepartmentType, DocType, SummaryStatus } from "./constants/disputeEntries";
import DetailedSummariesTable from "./DetailedSummariesTable";
import EntryDetailsDisputedEntries from "./EntryDetailsDisputedEntries";
import FilterOfDisputedEntries from "./FilterOfDisputedEntries";
import NonReconBulkActionDisputedEntries from "./NonRecon/NonReconBulkActionDisputedEntries";
import NonReconFilterOfDisputedEntries from "./NonRecon/NonReconFilterOfDisputedEntries";
import NonReconRemarksDisputedEntries from "./NonRecon/NonReconRemarksDisputedEntries";
import NonReconTakeActionDisputedEntries from "./NonRecon/NonReconTakeActionDisputedEntries";
import NonReconViewHistoryDisputedEntries from "./NonRecon/NonReconViewHistoryDisputedEntries";
import NonReconDetailedSummaryTable from "./NonReconDetailedSummaryTable";
import NonReconProgressTable from "./NonReconProgressTable";
import RemarksDisputedEntries from "./RemarksDisputedEntries";
import TakeActionDisputedEntries from "./TakeActionDisputedEntries";
import ViewHistoryDisputedEntries from "./ViewHistoryDisputedEntries";

const DisputedEntries = () => {
  const { actor } = useContext(userContext);
  const role =
    actor?.userRole === UserRole.DRMaker
      ? InstamartInternalProcessRole.MAKER
      : actor?.userRole === UserRole.DRChecker
      ? InstamartInternalProcessRole.CHECKER
      : actor?.userRole === UserRole.ReconDRApprover
      ? InstamartInternalProcessRole.CHECKER_APPROVER
      : actor?.userRole === UserRole.DRApprover
      ? InstamartInternalProcessRole.APPROVER
      : null;

  const location = useLocation<any>();
  const [selectedRows, setSelectedRows] = useState({});
  const [filters, setFilters] = useState([]);
  const [tableLoader, setTableLoader] = useState(false);
  const [showDetailedSummary, setShowDetailedSummary] = useState(false);
  const [selectedRowOfDisputedEntryForModal, setSelectedRowOfDisputedEntryForModal] = useState();
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [openTakeActionModal, setOpenTakeActionModal] = useState(false);
  const [openNonReconTakeActionModal, setOpenNonReconTakeActionModal] = useState(false);
  const [openViewHistoryModal, setOpenViewHistoryModal] = useState(false);
  const [openNonReconViewHistoryModal, setOpenNonReconViewHistoryModal] = useState(false);
  const [openEntryDetailsModal, setOpenEntryDetailsModal] = useState(false);
  const [openRemarksModal, setOpenRemarksModal] = useState(false);
  const [openNonReconRemarksModal, setOpenNonReconRemarksModal] = useState(false);
  const [openBulkActionModal, setOpenBulkActionModal] = useState(false);
  const [openNonReconBulkActionModal, setOpenNonReconBulkActionModal] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [openFilterOfDisputedEntries, setOpenFilterOfDisputedEntries] = useState(false);
  const [openNonReconFilterOfDisputedEntries, setOpenNonReconFilterOfDisputedEntries] = useState(false);
  const [isNonReconIssuesRaised, setIsNonReconIssuesRaised] = useState(false);

  // ------api integration----------
  const [summaryData, setSummaryData] = useState({});
  const [disputedEntriesData, setDisputedEntriesData] = useState([]);
  const [isShowVendorLevelSummary, setIsShowVendorLevelSummary] = useState(false);
  const [drEntryVendorSummary, setDrEntryVendorSummary] = useState([]);
  const [departmentName, setDepartmentName] = useState(null);
  const departmentNameRef = useRef(null);
  const partnerNameRef = useRef(null);
  const panRef = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingAll, setIsDownloadingAll] = useState(false);

  const [allUsers, setAllUsers] = useState([]);
  const [viewDetailedSummaries, setViewDetailedSummaries] = useState([
    {
      title: "Overall Disputed Summary",
      key: "Total",
      data: [],
    },
    {
      title: "Disputed Invoice Summary",
      key: DocType.Invoice,
      data: [],
    },
    {
      title: "Disputed Payments Summary",
      key: DocType.Payment,
      data: [],
    },
    { title: "Disputed PR/ RTV Summary", key: DocType.PRRTV, data: [] },
    { title: "Disputed Brand Promo Summary", key: DocType.BrandPromo, data: [] },
    { title: "Disputed Visibility Summary", key: DocType.Visibility, data: [] },
    { title: "Disputed Reversal Summary", key: DocType.Reversal, data: [] },
    { title: "Disputed Internal Document Summary", key: DocType.InternalDocument, data: [] },
    { title: "Disputed DNCN Summary", key: DocType.DNCN, data: [] },
  ]);
  const nonReconViewDetailedSummaries = [
    {
      title: "Overall Disputed Summary",
      key: "Total",
      data: [
        {
          stakeholder: "Finance",
          Total: "588864",
          "0-7 Days": "554411",
          "8-15 Days": "0",
          "16-30 Days": "34453",
          "31-45 Days": "0",
          "45-90 Days": "0",
          ">90 Days": "0",
          subRows: [
            {
              stakeholder: "Action disputed by vendor, finance to check",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Finance to provide GDN Copy, POD Copy and Associated Invoice Number",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Finance to review the details",
              Total: "554411",
              "0-7 Days": "554511",
              "8-15 Days": "0",
              "16-30 Days": "34453",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "GRN Shared by Warehouse team",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Instamart needs to book",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "No revise PO details",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Instamart needs to reverse",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
          ],
        },
        {
          stakeholder: "Procurement",
          Total: "0",
          "0-7 Days": "0",
          "8-15 Days": "0",
          "16-30 Days": "0",
          "31-45 Days": "0",
          "45-90 Days": "0",
          ">90 Days": "0",
          subRows: [
            {
              stakeholder: "Require Confirmation from procurement",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Require Confirmation or Revised PO details from procurement",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
          ],
        },
        {
          stakeholder: "Vendor",
          Total: "9554749",
          "0-7 Days": "3110491",
          "8-15 Days": "0",
          "16-30 Days": "6444258",
          "31-45 Days": "0",
          "45-90 Days": "0",
          ">90 Days": "0",
          subRows: [
            {
              stakeholder: "Vendor needs to confirm &  to book",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Vendor needs to confirm and reverse",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Vendor to upload Correct POD copy & Invoice Copy",
              Total: "7767442",
              "0-7 Days": "3110491",
              "8-15 Days": "0",
              "16-30 Days": "4556951",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Vendor to share the correct POD copies",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "1787307",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
          ],
        },
        {
          stakeholder: "Warehouse",
          Total: "3064639",
          "0-7 Days": "0",
          "8-15 Days": "980296",
          "16-30 Days": "2084343",
          "31-45 Days": "0",
          "45-90 Days": "0",
          ">90 Days": "0",
          subRows: [
            {
              stakeholder: "GRN Validation required from Warehouse",
              Total: "3011824",
              "0-7 Days": "0",
              "8-15 Days": "980296",
              "16-30 Days": "2031528",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Need approval from the Leadership team",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "PO Number is shared by Procurement team",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Warehouse to share POD details and Mail communication",
              Total: "52815",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "52815",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Clarification pending from warehouse",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
          ],
        },
      ],
    },
    {
      title: "Disputed Invoice Summary",
      key: DocType.Invoice,
      data: [
        {
          stakeholder: "Finance",
          Total: "588864",
          "0-7 Days": "554411",
          "8-15 Days": "0",
          "16-30 Days": "34453",
          "31-45 Days": "0",
          "45-90 Days": "0",
          ">90 Days": "0",
          subRows: [
            {
              stakeholder: "Action disputed by vendor, finance to check",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Finance to review the details",
              Total: "588864",
              "0-7 Days": "554411",
              "8-15 Days": "0",
              "16-30 Days": "34453",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "GRN Shared by Warehouse team",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Instamart needs to book",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "No revise PO details",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
          ],
        },
        {
          stakeholder: "Procurement",
          Total: "0",
          "0-7 Days": "0",
          "8-15 Days": "0",
          "16-30 Days": "0",
          "31-45 Days": "0",
          "45-90 Days": "0",
          ">90 Days": "0",
          subRows: [
            {
              stakeholder: "Require Confirmation from procurement",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
          ],
        },
        {
          stakeholder: "Vendor",
          Total: "7767442",
          "0-7 Days": "3110491",
          "8-15 Days": "0",
          "16-30 Days": "4656951",
          "31-45 Days": "0",
          "45-90 Days": "0",
          ">90 Days": "0",
          subRows: [
            {
              stakeholder: "Vendor to upload Correct POD copy & Invoice Copy",
              Total: "7767442",
              "0-7 Days": "3110491",
              "8-15 Days": "0",
              "16-30 Days": "4656951",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Vendor needs to confirm and reverse",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
          ],
        },
        {
          stakeholder: "Warehouse",
          Total: "3011824",
          "0-7 Days": "0",
          "8-15 Days": "980296",
          "16-30 Days": "2031528",
          "31-45 Days": "0",
          "45-90 Days": "0",
          ">90 Days": "0",
          subRows: [
            {
              stakeholder: "GRN Validation required from Warehouse",
              Total: "3011824",
              "0-7 Days": "0",
              "8-15 Days": "980296",
              "16-30 Days": "2031528",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Need approval from the Leadership team",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "PO Number is shared by Procurement team",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
          ],
        },
      ],
    },

    {
      title: "Disputed PR/ RTV Summary",
      key: DocType.PRRTV,
      data: [
        {
          stakeholder: "Finance",
          Total: "0",
          "0-7 Days": "0",
          "8-15 Days": "0",
          "16-30 Days": "0",
          "31-45 Days": "0",
          "45-90 Days": "0",
          ">90 Days": "0",
          subRows: [
            {
              stakeholder: "Finance to provide GDN Copy, POD Copy and Associated Invoice Number",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Finance to review the details",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Instamart needs to reverse",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Action disputed by vendor, finance to check",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
          ],
        },
        {
          stakeholder: "Procurement",
          Total: "0",
          "0-7 Days": "0",
          "8-15 Days": "0",
          "16-30 Days": "0",
          "31-45 Days": "0",
          "45-90 Days": "0",
          ">90 Days": "0",
          subRows: [
            {
              stakeholder: "Require Confirmation from procurement",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
          ],
        },
        {
          stakeholder: "Vendor",
          Total: "1787307",
          "0-7 Days": "0",
          "8-15 Days": "0",
          "16-30 Days": "1787307",
          "31-45 Days": "0",
          "45-90 Days": "0",
          ">90 Days": "0",
          subRows: [
            {
              stakeholder: "Vendor to confirm and book",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Vendor to share the correct POD copies",
              Total: "1787307",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "1787307",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
          ],
        },
        {
          stakeholder: "Warehouse",
          Total: "52815",
          "0-7 Days": "0",
          "8-15 Days": "0",
          "16-30 Days": "52815",
          "31-45 Days": "0",
          "45-90 Days": "0",
          ">90 Days": "0",
          subRows: [
            {
              stakeholder: "Warehouse to share POD details and Mail communication",
              Total: "52815",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "52815",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Need approval from the Leadership team",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
            {
              stakeholder: "Clarification pending from warehouse",
              Total: "0",
              "0-7 Days": "0",
              "8-15 Days": "0",
              "16-30 Days": "0",
              "31-45 Days": "0",
              "45-90 Days": "0",
              ">90 Days": "0",
            },
          ],
        },
      ],
    },
  ];

  //----------------ed-------------

  // Define a mapping function for dynamic properties using SummaryStatus enum
  const getSummaryCardProperties = (title) => {
    const properties = {
      [SummaryStatus.DocsPending]: {
        icon: <AssignmentIcon />,
        bgColor: "#ECEFF1",
        iconBgColor: "#eceff1",
        iconColor: "#607d8b",
      },
      [SummaryStatus.BookingPending]: {
        icon: <HourglassEmptyIcon />,
        bgColor: "#FFF8E1",
        iconBgColor: "#fff8e1",
        iconColor: "#ffa000",
      },
      [SummaryStatus.RequireConfirmation]: {
        icon: <SearchIcon />,
        bgColor: "#FEEBEE",
        iconBgColor: "#feebee",
        iconColor: "#f44336",
      },
      [SummaryStatus.Resolved]: {
        icon: <UploadIcon />,
        bgColor: "#E8F5E9",
        iconBgColor: "#e8f5e9",
        iconColor: "#4caf50",
      },
      [SummaryStatus.ClarificationPending]: {
        icon: <HourglassEmptyIcon />,
        bgColor: "#FFF8E1",
        iconBgColor: "#fff8e1",
        iconColor: "#ffa000",
      },
      [SummaryStatus.ReviewPending]: {
        icon: <HourglassEmptyIcon />,
        bgColor: "#FFF8E1",
        iconBgColor: "#fff8e1",
        iconColor: "#ffa000",
      },
      [SummaryStatus.ApprovedForBooking]: {
        icon: <DoneAllIcon />,
        bgColor: "#E3F2FD",
        iconBgColor: "#E3F2FD",
        iconColor: "#2196f3",
      },
      [SummaryStatus.LeadershipApprovalRequired]: {
        icon: <SearchIcon />,
        bgColor: "#FEEBEE",
        iconBgColor: "#feebee",
        iconColor: "#f44336",
      },
    };

    return properties[title] || {};
  };

  // Function to generate summary data from Excel data based on dependency and resolution status
  const generateSummaryFromData = (tableData, isNonReconView = isNonReconIssuesRaised) => {
    const currentDepartment = departmentNameRef.current;

    // Define fixed summaryResult with all dependencies and titles
    const allSummaryResult = {
      finance: [
        { title: "Docs Pending", amount: "₹0", count: 0, dependency: "Finance" },
        { title: "Review Pending", amount: "₹0", count: 0, dependency: "Finance" },
        { title: "Approved for Booking", amount: "₹0", count: 0, dependency: "Finance" },
        { title: "Resolved", amount: "₹0", count: 0, dependency: "Finance" },
      ],
      warehouse: [
        { title: "Docs Pending", amount: "₹0", count: 0, dependency: "Warehouse" },
        { title: "Clarification Pending", amount: "₹0", count: 0, dependency: "Warehouse" },
        { title: "Leadership Approval Required", amount: "₹0", count: 0, dependency: "Warehouse" },
      ],
      procurement: [{ title: "Require Confirmation", amount: "₹0", count: 0, dependency: "Procurement" }],
      arTeam: [{ title: "Clarification Pending", amount: "₹0", count: 0, dependency: "AR" }],
      // btpl: [{ title: "Clarification Pending", amount: "₹0", count: 0, dependency: "BTPL" }],
      category: [{ title: "Require Confirmation", amount: "₹0", count: 0, dependency: "Category" }],
      vendor: [
        { title: "Docs Pending", amount: "₹0", count: 0, dependency: "Vendor" },
        { title: "Booking Pending", amount: "₹0", count: 0, dependency: "Vendor" },
        { title: "Clarification Pending", amount: "₹0", count: 0, dependency: "Vendor" },
        { title: "Resolved", amount: "₹0", count: 0, dependency: "Vendor" },
      ],
    };

    // Filter summaryResult based on departmentNameRef.current
    let summaryResult: any = allSummaryResult;

    // ReconDRApprover should always see all departments regardless of their assigned department
    // For other roles, only Finance department can see all departments
    if (
      actor?.userRole !== UserRole.ReconDRApprover &&
      currentDepartment &&
      currentDepartment !== DepartmentType.Finance
    ) {
      const departmentKeyMapping = {
        [DepartmentType.Warehouse]: "warehouse", // "Inwarding" -> warehouse
        [DepartmentType.Vendor]: "vendor", // "Vendor" -> vendor
        [DepartmentType.Procurement]: "procurement", // "Procurement" -> procurement
        [DepartmentType.ARTeam]: "arTeam", // "AR" -> arTeam
        // [DepartmentType.BTPL]: "btpl", // "BTPL" -> btpl
        [DepartmentType.Category]: "category", // "Category" -> category
      };

      const selectedDepartmentKey = departmentKeyMapping[currentDepartment];

      if (selectedDepartmentKey && allSummaryResult[selectedDepartmentKey]) {
        summaryResult = {
          [selectedDepartmentKey]: allSummaryResult[selectedDepartmentKey],
        };
      }
    }

    // Map lowercase dependency keys to enum display values
    const dependencyMapping = {
      finance: "Finance",
      warehouse: "Warehouse",
      procurement: "Procurement",
      arTeam: "AR",
      // btpl: "BTPL",
      category: "Category",
      vendor: "Vendor",
    };

    // Process excelData
    tableData.forEach((row) => {
      const dependency = row.dependency?.toString().toLowerCase().trim() || "";
      const resolutionStatus = row.resolutionStatus?.toString().trim() || "";
      const disputedAmount = isNonReconView
        ? (parseFloat(row.dncnAmount) || 0) + (parseFloat(row.invoiceAmount) || 0)
        : parseFloat(row.disputedAmount) || 0;

      const depKey = Object.keys(dependencyMapping).find(
        (key) => dependencyMapping[key].toLowerCase() === dependency.toLowerCase()
      );

      if (!depKey) return;

      const statusEntry = summaryResult[depKey]?.find(
        (item) => item.title.toLowerCase() === resolutionStatus.toLowerCase()
      );

      if (statusEntry) {
        statusEntry.count += 1;
        const currentAmount = parseFloat(statusEntry.amount.replace(/[₹,-]/g, "")) || 0;
        const newAmount = currentAmount + disputedAmount;
        statusEntry.amount =
          newAmount >= 0
            ? `₹${Math.abs(Math.round(newAmount)).toLocaleString("en-IN")}`
            : `-₹${Math.abs(Math.round(newAmount)).toLocaleString("en-IN")}`;
      }
    });
    return summaryResult;
  };

  // Define ReactTable columns
  const columnDefinition = useMemo(
    (): any => [
      {
        header: "Resolution Status",
        id: "resolutionStatus",
        accessorFn: (row) => row.resolutionStatus || "",
        filterVariant: "multi-select",
        size: 230,
        Cell: ({ cell }) => {
          const status = cell.getValue() as string;
          let chipColor: "primary" | "warning" | "success" | "default" | "secondary" | "error" | "info" = "default";

          // Use SummaryStatus enum for consistent status matching
          switch (status) {
            case SummaryStatus.Resolved:
              chipColor = "success";
              break;
            case SummaryStatus.ReviewPending:
            case SummaryStatus.ClarificationPending:
            case SummaryStatus.BookingPending:
              chipColor = "warning";
              break;
            case SummaryStatus.ApprovedForBooking:
              chipColor = "info";
              break;
            case SummaryStatus.DocsPending:
              chipColor = "secondary";
              break;
            case SummaryStatus.LeadershipApprovalRequired:
            case SummaryStatus.RequireConfirmation:
              chipColor = "error";
              break;
            default:
              chipColor = "default";
              break;
          }

          return <Chip label={status} size="small" color={chipColor} variant="filled" sx={{ fontWeight: 400 }} />;
        },
      },
      {
        header: "Action ",
        id: "action",
        accessorFn: (row) => row.action || "",
        filterVariant: "multi-select",
        size: 350,
      },
      {
        header: "Dependency",
        id: "dependency",
        accessorFn: (row) => row.dependency || "",
        filterVariant: "multi-select",
        size: 180,
      },
      {
        header: "Gap reason",
        id: "gapReason",
        accessorFn: (row) => row.gapReason || "",
        filterVariant: "multi-select",
        size: 350,
      },
      {
        header: "Disputed Amount",
        id: "disputedAmount",
        accessorFn: (row) => parseFloat(row.disputedAmount) || 0,
        size: 280,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div
            className="textOverflow_hidden"
            title={row.original?.disputedAmount ? formatMoney(ToDineroObj(row.original?.disputedAmount)) : ""}
          >
            {row.original?.disputedAmount ? formatMoney(ToDineroObj(row.original?.disputedAmount)) : "-"}
          </div>
        ),
      },
      {
        header: "Priority",
        id: "priority",
        accessorFn: (row) => row.priority || "",
        filterVariant: "multi-select",
        size: 180,
      },
      {
        header: "Due Date",
        id: "dueDate",
        accessorFn: (row) => row.dueDate || "",
        size: 320,
        filterVariant: "date-range",

        filterFn: (row, _, filterValue) => {
          const startDate = filterValue[0] && filterValue[0].$d;
          const endDate = filterValue[1] && filterValue[1].$d;
          return filterDateBetweenStartAndEndDate(startDate, endDate, row.original.dueDate);
        },
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">{row.original?.dueDate ? formatDate(row.original?.dueDate) : "-"}</div>
        ),
      },
      {
        header: "Recon Status",
        id: "reconStatus",
        accessorFn: (row) => row.reconStatus || "",
        filterVariant: "multi-select",
        size: 350,
      },

      {
        header: "Doc type",
        id: "docType",
        accessorFn: (row) => row.docType || "",
        filterVariant: "multi-select",
        size: 180,
      },
      {
        header: "Maker",
        id: "maker",
        accessorFn: (row) => row.maker || "",
        size: 200,
      },
      {
        header: "Checker",
        id: "checker",
        accessorFn: (row) => row.checker || "",
        size: 200,
      },
      {
        header: "Approver",
        id: "approver",
        accessorFn: (row) => row.approver || "",
        size: 200,
      },
      {
        header: "Vendor Name",
        id: "businessPartnerName",
        accessorFn: (row) => row.businessPartnerName || "",
        size: 230,
      },
      {
        header: "Vendor Pan",
        id: "pan",
        accessorFn: (row) => row.pan || "",
        size: 230,
      },
      {
        header: "Task Id",
        id: "ticketId",
        accessorFn: (row) => row.ticketId || "",
        size: 200,
      },
      {
        header: "Vendor Invoice Number",
        id: "vendorInvoiceNumber",
        accessorFn: (row) => row.vendorInvoiceNumber || "",
        size: 230,
      },
      {
        header: "Instamart DN Number",
        id: "instamartDnNumber",
        accessorFn: (row) => row.instamartDnNumber || "",
        size: 230,
      },
      {
        header: "PO Number",
        id: "poNumber",
        accessorFn: (row) => row?.poNumber || "",
        size: 230,
      },
      {
        header: "Comments",
        id: "newVendorComments",
        accessorFn: (row) => (row.newVendorComments ? "Unread" : "Read"),
        size: 180,
        filterVariant: "multi-select",
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {/*  its boolean */}
            {row.original?.newVendorComments ? "Unread" : "Read"}
          </div>
        ),
      },
      {
        header: "Dispute Status",
        id: "vendorDisputeStatus",
        accessorFn: (row) => row.vendorDisputeStatus || "",
        filterVariant: "multi-select",
        size: 230,
      },
      {
        header: "Entity",
        id: "entity",
        accessorFn: (row) => row.entity || "",
        filterVariant: "multi-select",
        size: 230,
      },
      {
        header: "Actions",
        id: "actions",
        enableColumnFilter: false,
        enableSorting: false,
        size: 265,
        Cell: ({ row }) => (
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <CustomButton
              size="small"
              variant="outlined"
              sx={{
                minWidth: "auto",
                px: 2,
                borderColor: "#531c4c",
                color: "#531c4c",
                "&:hover": {
                  borderColor: "#531c4c",
                  backgroundColor: "rgba(83, 28, 76, 0.04)",
                },
              }}
              className="heading-xxs"
              onClick={() => {
                setSelectedRowOfDisputedEntryForModal(row.original);
                setSelectedRowIndex(row.index);
                setOpenTakeActionModal(true);
              }}
            >
              Take action
            </CustomButton>

            <IconButton
              size="small"
              sx={{ color: "#531c4c" }}
              onClick={() => {
                setSelectedRowOfDisputedEntryForModal(row.original);
                setOpenRemarksModal(true);
              }}
            >
              <Tooltip title="Remarks">
                <ChatBubbleOutlineIcon />
              </Tooltip>
            </IconButton>
            <IconButton
              size="small"
              sx={{ color: "#531c4c" }}
              onClick={() => {
                setSelectedRowOfDisputedEntryForModal(row.original);
                setOpenEntryDetailsModal(true);
              }}
            >
              <Tooltip title="Entry Details">
                <ContentPasteIcon />
              </Tooltip>
            </IconButton>
            <IconButton
              size="small"
              sx={{ color: "#531c4c" }}
              onClick={() => {
                setSelectedRowOfDisputedEntryForModal(row.original);
                setOpenViewHistoryModal(true);
              }}
            >
              <Tooltip title="View History">
                <AccessTimeIcon />
              </Tooltip>
            </IconButton>
          </Box>
        ),
      },
    ],
    []
  );
  const columnDefinitionNonRecon = useMemo(
    (): any => [
      {
        header: "Resolution Status",
        id: "resolutionStatus",
        accessorFn: (row) => row.resolutionStatus || "",
        filterVariant: "multi-select",
        size: 230,
        Cell: ({ cell }) => {
          const status = cell.getValue() as string;
          let chipColor: "primary" | "warning" | "success" | "default" | "secondary" | "error" | "info" = "default";

          // Use SummaryStatus enum for consistent status matching
          switch (status) {
            case SummaryStatus.Resolved:
              chipColor = "success";
              break;
            case SummaryStatus.ReviewPending:
            case SummaryStatus.ClarificationPending:
            case SummaryStatus.BookingPending:
              chipColor = "warning";
              break;
            case SummaryStatus.ApprovedForBooking:
              chipColor = "info";
              break;
            case SummaryStatus.DocsPending:
              chipColor = "secondary";
              break;
            case SummaryStatus.LeadershipApprovalRequired:
            case SummaryStatus.RequireConfirmation:
              chipColor = "error";
              break;
            default:
              chipColor = "default";
              break;
          }

          return <Chip label={status} size="small" color={chipColor} variant="filled" sx={{ fontWeight: 400 }} />;
        },
      },
      {
        header: "Action ",
        id: "action",
        accessorFn: (row) => row.action || "",
        filterVariant: "multi-select",
        size: 350,
      },
      {
        header: "Dependency",
        id: "dependency",
        accessorFn: (row) => row.dependency || "",
        filterVariant: "multi-select",
        size: 180,
      },

      {
        header: "Disputed Amount",
        id: "disputedAmount",
        accessorFn: (row) => {
          const dncnAmount = parseFloat(row.dncnAmount) || 0;
          const invoiceAmount = parseFloat(row.invoiceAmount) || 0;
          return dncnAmount + invoiceAmount;
        },
        size: 280,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => {
          const dncnAmount = parseFloat(row.original?.dncnAmount) || 0;
          const invoiceAmount = parseFloat(row.original?.invoiceAmount) || 0;
          const disputedAmount = dncnAmount + invoiceAmount;
          return (
            <div className="textOverflow_hidden" title={disputedAmount ? formatMoney(ToDineroObj(disputedAmount)) : ""}>
              {disputedAmount ? formatMoney(ToDineroObj(disputedAmount)) : "-"}
            </div>
          );
        },
      },

      {
        header: "Doc type",
        id: "docType",
        accessorFn: (row) => row.docType || "",
        filterVariant: "multi-select",
        size: 180,
      },
      {
        header: "Invoice Number",
        id: "invoiceNumber",
        accessorFn: (row) => row.invoiceNumber || "",
        size: 230,
      },
      {
        header: "Instamart DN Number",
        id: "instamartDNNumber",
        accessorFn: (row) => row.instamartDNNumber || "",
        size: 280,
      },
      {
        header: "Invoice date",
        id: "invoiceDate",
        accessorFn: (row) => row.invoiceDate || "",
        size: 320,
        filterVariant: "date-range",

        filterFn: (row, _, filterValue) => {
          const startDate = filterValue[0] && filterValue[0].$d;
          const endDate = filterValue[1] && filterValue[1].$d;
          return filterDateBetweenStartAndEndDate(startDate, endDate, row.original.invoiceDate);
        },
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.invoiceDate ? formatDate(row.original?.invoiceDate) : "-"}
          </div>
        ),
      },
      {
        header: "Debit note date",
        id: "debitNoteDate",
        accessorFn: (row) => row.debitNoteDate || "",
        size: 320,
        filterVariant: "date-range",

        filterFn: (row, _, filterValue) => {
          const startDate = filterValue[0] && filterValue[0].$d;
          const endDate = filterValue[1] && filterValue[1].$d;
          return filterDateBetweenStartAndEndDate(startDate, endDate, row.original.debitNoteDate);
        },
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.debitNoteDate ? formatDate(row.original?.debitNoteDate) : "-"}
          </div>
        ),
      },

      {
        header: "Organization name",
        id: "organizationName",
        filterVariant: "multi-select",
        accessorFn: (row) => row.organizationName || "",
        size: 280,
      },
      {
        header: "PO number",
        id: "poNumber",
        accessorFn: (row) => row.poNumber || "",
        filterVariant: "multi-select",
        size: 230,
      },
      {
        header: "Actions",
        id: "actions",
        enableColumnFilter: false,
        enableSorting: false,
        size: 220,
        Cell: ({ row }) => (
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <CustomButton
              size="small"
              variant="outlined"
              sx={{
                minWidth: "auto",
                px: 2,
                borderColor: "#531c4c",
                color: "#531c4c",
                "&:hover": {
                  borderColor: "#531c4c",
                  backgroundColor: "rgba(83, 28, 76, 0.04)",
                },
              }}
              className="heading-xxs"
              onClick={() => {
                setSelectedRowOfDisputedEntryForModal(row.original);
                setSelectedRowIndex(row.index);
                setOpenNonReconTakeActionModal(true);
              }}
            >
              Take action
            </CustomButton>

            <IconButton
              size="small"
              sx={{ color: "#531c4c" }}
              onClick={() => {
                setSelectedRowOfDisputedEntryForModal(row.original);
                setOpenNonReconRemarksModal(true);
              }}
            >
              <Tooltip title="Remarks">
                <ChatBubbleOutlineIcon />
              </Tooltip>
            </IconButton>
            {/* <IconButton
              size="small"
              sx={{ color: "#531c4c" }}
              onClick={() => {
                setSelectedRowOfDisputedEntryForModal(row.original);
                setOpenEntryDetailsModal(true);
              }}
            >
              <Tooltip title="Entry Details">
                <ContentPasteIcon />
              </Tooltip>
            </IconButton> */}
            <IconButton
              size="small"
              sx={{ color: "#531c4c" }}
              onClick={() => {
                setSelectedRowOfDisputedEntryForModal(row.original);
                setOpenNonReconViewHistoryModal(true);
              }}
            >
              <Tooltip title="View History">
                <AccessTimeIcon />
              </Tooltip>
            </IconButton>
          </Box>
        ),
      },
    ],
    []
  );

  const columnDefinitionSummary = useMemo(
    (): any => [
      {
        header: "Vendor Name",
        id: "partnerName",
        accessorFn: (row) => row.partnerName || "",
        size: 350,
        Cell: ({ row }: any) => (
          <div
            className="textOverflow_hidden"
            title={row.original?.partnerName}
            style={{ color: "blue", cursor: "pointer" }}
            onClick={() => {
              setIsShowVendorLevelSummary(true);
              partnerNameRef.current = row.original?.partnerName;
              panRef.current = row.original?.pan;
              listDrEntries(row.original?.partnerName, false);
              detailedSummaryOnDependency(row.original?.partnerName);
              detailedSummaryOnDependencyAndDocType(row.original?.partnerName);
            }}
          >
            {row.original?.partnerName}
          </div>
        ),
      },
      {
        header: "PAN",
        id: "pan",
        accessorFn: (row) => row.pan || "",
        size: 180,
      },
      {
        header: "Priority",
        id: "priority",
        accessorFn: (row) => row.priority || "",
        size: 200,
      },
      {
        header: "Total Disputed Amount",
        id: "totalDisputedAmount",
        accessorFn: (row) => parseFloat(row.totalDisputedAmount) || 0,
        size: 260,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div
            className="textOverflow_hidden"
            title={row.original?.totalDisputedAmount ? formatMoney(ToDineroObj(row.original?.totalDisputedAmount)) : ""}
          >
            {row.original?.totalDisputedAmount ? formatMoney(ToDineroObj(row.original?.totalDisputedAmount)) : "-"}
          </div>
        ),
      },
      {
        header: "Grn Dispute Amount",
        id: "GRNDispute",
        accessorFn: (row) => parseFloat(row.GRNDispute) || 0,
        size: 270,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div
            className="textOverflow_hidden"
            title={row.original?.GRNDispute ? formatMoney(ToDineroObj(row.original?.GRNDispute)) : ""}
          >
            {row.original?.GRNDispute ? formatMoney(ToDineroObj(row.original?.GRNDispute)) : "-"}
          </div>
        ),
      },
      {
        header: "PR/RTV Dispute Amount",
        id: "PRRTVDispute",
        accessorFn: (row) => parseFloat(row.PRRTVDispute) || 0,
        size: 270,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div
            className="textOverflow_hidden"
            title={row.original?.PRRTVDispute ? formatMoney(ToDineroObj(row.original?.PRRTVDispute)) : ""}
          >
            {row.original?.PRRTVDispute ? formatMoney(ToDineroObj(row.original?.PRRTVDispute)) : "-"}
          </div>
        ),
      },
      {
        header: "AR Dispute Amount",
        id: "ARDispute",
        accessorFn: (row) => parseFloat(row.ARDispute) || 0,
        size: 270,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div
            className="textOverflow_hidden"
            title={row.original?.ARDispute ? formatMoney(ToDineroObj(row.original?.ARDispute)) : ""}
          >
            {row.original?.ARDispute ? formatMoney(ToDineroObj(row.original?.ARDispute)) : "-"}
          </div>
        ),
      },
      {
        header: "Other Dispute Amount",
        id: "OtherDispute",
        accessorFn: (row) => parseFloat(row.OtherDispute) || 0,
        size: 270,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div
            className="textOverflow_hidden"
            title={row.original?.OtherDispute ? formatMoney(ToDineroObj(row.original?.OtherDispute)) : ""}
          >
            {row.original?.OtherDispute ? formatMoney(ToDineroObj(row.original?.OtherDispute)) : "-"}
          </div>
        ),
      },
      {
        header: "Finance Pendency (Amount)",
        id: "financePendencyAmount",
        accessorFn: (row) => parseFloat(row.financePendencyAmount) || 0,
        size: 260,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.financePendencyAmount ? formatMoney(ToDineroObj(row.original.financePendencyAmount)) : "-"}
          </div>
        ),
      },
      {
        header: "Finance Pendency (Count)",
        id: "financePendencyCount",
        accessorFn: (row) => parseInt(row.financePendencyCount) || 0,
        size: 230,
        enableColumnFilter: false,
      },
      {
        header: "Warehouse Pendency (Amount)",
        id: "warehousePendencyAmount",
        accessorFn: (row) => parseFloat(row.warehousePendencyAmount) || 0,
        size: 270,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.warehousePendencyAmount
              ? formatMoney(ToDineroObj(row.original.warehousePendencyAmount))
              : "-"}
          </div>
        ),
      },
      {
        header: "Warehouse Pendency (Count)",
        id: "warehousePendencyCount",
        accessorFn: (row) => parseInt(row.warehousePendencyCount) || 0,
        size: 240,
        enableColumnFilter: false,
      },
      {
        header: "Procurement Pendency (Amount)",
        id: "procurementPendencyAmount",
        accessorFn: (row) => parseFloat(row.procurementPendencyAmount) || 0,
        size: 280,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.procurementPendencyAmount
              ? formatMoney(ToDineroObj(row.original.procurementPendencyAmount))
              : "-"}
          </div>
        ),
      },
      {
        header: "Procurement Pendency (Count)",
        id: "procurementPendencyCount",
        accessorFn: (row) => parseInt(row.procurementPendencyCount) || 0,
        size: 260,
        enableColumnFilter: false,
      },
      {
        header: "Vendor Pendency (Amount)",
        id: "vendorPendencyAmount",
        accessorFn: (row) => parseFloat(row.vendorPendencyAmount) || 0,
        size: 260,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.vendorPendencyAmount ? formatMoney(ToDineroObj(row.original.vendorPendencyAmount)) : "-"}
          </div>
        ),
      },
      {
        header: "Vendor Pendency (Count)",
        id: "vendorPendencyCount",
        accessorFn: (row) => parseInt(row.vendorPendencyCount) || 0,
        size: 230,
        enableColumnFilter: false,
      },
      {
        header: "AR Team Pendency (Amount)",
        id: "arTeamPendencyAmount",
        accessorFn: (row) => parseFloat(row.arTeamPendencyAmount) || 0,
        size: 270,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.arTeamPendencyAmount ? formatMoney(ToDineroObj(row.original.arTeamPendencyAmount)) : "-"}
          </div>
        ),
      },
      {
        header: "AR Team Pendency (Count)",
        id: "arTeamPendencyCount",
        accessorFn: (row) => parseInt(row.arTeamPendencyCount) || 0,
        size: 240,
        enableColumnFilter: false,
      },
      {
        header: "Category Pendency (Amount)",
        id: "categoryPendencyAmount",
        accessorFn: (row) => parseFloat(row.categoryPendencyAmount) || 0,
        size: 270,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.categoryPendencyAmount ? formatMoney(ToDineroObj(row.original.categoryPendencyAmount)) : "-"}
          </div>
        ),
      },
      {
        header: "Category Pendency (Count)",
        id: "categoryPendencyCount",
        accessorFn: (row) => parseInt(row.categoryPendencyCount) || 0,
        size: 240,
        enableColumnFilter: false,
      },
      {
        header: "Last Updated On",
        id: "lastUpdatedOn",
        accessorFn: (row) => row.lastUpdatedOn || "",
        size: 220,
        enableColumnFilter: false,
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.lastUpdatedOn ? formatDate(row.original.lastUpdatedOn) : "-"}
          </div>
        ),
      },
    ],
    []
  );
  const columnDefinitionSummaryNonRecon = useMemo(
    (): any => [
      {
        header: "Vendor Name",
        id: "partnerName",
        accessorFn: (row) => row.partnerName || "",
        size: 350,
        Cell: ({ row }: any) => (
          <div
            className="textOverflow_hidden"
            title={row.original?.partnerName}
            style={{ color: "blue", cursor: "pointer" }}
            onClick={() => {
              setIsShowVendorLevelSummary(true);
              partnerNameRef.current = row.original?.partnerName;
              panRef.current = row.original?.pan;
              listDrEntries(row.original?.partnerName, true);
              // detailedSummaryOnDependency(row.original?.partnerName);
              // detailedSummaryOnDependencyAndDocType(row.original?.partnerName);
            }}
          >
            {row.original?.partnerName}
          </div>
        ),
      },
      {
        header: "PAN",
        id: "pan",
        accessorFn: (row) => row.pan || "",
        size: 180,
      },

      {
        header: "Grn Dispute Amount",
        id: "GRNDispute",
        accessorFn: (row) => parseFloat(row.GRNDispute) || 0,
        size: 270,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div
            className="textOverflow_hidden"
            title={row.original?.GRNDispute ? formatMoney(ToDineroObj(row.original?.GRNDispute)) : ""}
          >
            {row.original?.GRNDispute ? formatMoney(ToDineroObj(row.original?.GRNDispute)) : "-"}
          </div>
        ),
      },
      {
        header: "PR/RTV Dispute Amount",
        id: "PRRTVDispute",
        accessorFn: (row) => parseFloat(row.PRRTVDispute) || 0,
        size: 270,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div
            className="textOverflow_hidden"
            title={row.original?.PRRTVDispute ? formatMoney(ToDineroObj(row.original?.PRRTVDispute)) : ""}
          >
            {row.original?.PRRTVDispute ? formatMoney(ToDineroObj(row.original?.PRRTVDispute)) : "-"}
          </div>
        ),
      },
      {
        header: "Total Disputed Amount ",
        id: "totalDisputedAmount",
        accessorFn: (row) => parseFloat(row.totalDisputedAmount) || 0,
        size: 260,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div
            className="textOverflow_hidden"
            title={row.original?.totalDisputedAmount ? formatMoney(ToDineroObj(row.original?.totalDisputedAmount)) : ""}
          >
            {row.original?.totalDisputedAmount ? formatMoney(ToDineroObj(row.original?.totalDisputedAmount)) : "-"}
          </div>
        ),
      },
      {
        header: "Finance Pendency (Amount)",
        id: "financePendencyAmount",
        accessorFn: (row) => parseFloat(row.financePendencyAmount) || 0,
        size: 260,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.financePendencyAmount ? formatMoney(ToDineroObj(row.original.financePendencyAmount)) : "-"}
          </div>
        ),
      },
      {
        header: "Finance Pendency (Count)",
        id: "financePendencyCount",
        accessorFn: (row) => parseInt(row.financePendencyCount) || 0,
        size: 230,
        enableColumnFilter: false,
      },
      {
        header: "Warehouse Pendency (Amount)",
        id: "warehousePendencyAmount",
        accessorFn: (row) => parseFloat(row.warehousePendencyAmount) || 0,
        size: 270,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.warehousePendencyAmount
              ? formatMoney(ToDineroObj(row.original.warehousePendencyAmount))
              : "-"}
          </div>
        ),
      },
      {
        header: "Warehouse Pendency (Count)",
        id: "warehousePendencyCount",
        accessorFn: (row) => parseInt(row.warehousePendencyCount) || 0,
        size: 240,
        enableColumnFilter: false,
      },
      {
        header: "Procurement Pendency (Amount)",
        id: "procurementPendencyAmount",
        accessorFn: (row) => parseFloat(row.procurementPendencyAmount) || 0,
        size: 280,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.procurementPendencyAmount
              ? formatMoney(ToDineroObj(row.original.procurementPendencyAmount))
              : "-"}
          </div>
        ),
      },
      {
        header: "Procurement Pendency (Count)",
        id: "procurementPendencyCount",
        accessorFn: (row) => parseInt(row.procurementPendencyCount) || 0,
        size: 260,
        enableColumnFilter: false,
      },
      {
        header: "Vendor Pendency (Amount)",
        id: "vendorPendencyAmount",
        accessorFn: (row) => parseFloat(row.vendorPendencyAmount) || 0,
        size: 260,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.vendorPendencyAmount ? formatMoney(ToDineroObj(row.original.vendorPendencyAmount)) : "-"}
          </div>
        ),
      },
      {
        header: "Vendor Pendency (Count)",
        id: "vendorPendencyCount",
        accessorFn: (row) => parseInt(row.vendorPendencyCount) || 0,
        size: 230,
        enableColumnFilter: false,
      },
      {
        header: "AR Team Pendency (Amount)",
        id: "arTeamPendencyAmount",
        accessorFn: (row) => parseFloat(row.arTeamPendencyAmount) || 0,
        size: 270,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.arTeamPendencyAmount ? formatMoney(ToDineroObj(row.original.arTeamPendencyAmount)) : "-"}
          </div>
        ),
      },
      {
        header: "AR Team Pendency (Count)",
        id: "arTeamPendencyCount",
        accessorFn: (row) => parseInt(row.arTeamPendencyCount) || 0,
        size: 240,
        enableColumnFilter: false,
      },
      {
        header: "Category Pendency (Amount)",
        id: "categoryPendencyAmount",
        accessorFn: (row) => parseFloat(row.categoryPendencyAmount) || 0,
        size: 270,
        filterVariant: "range",
        filterFn: "betweenInclusive",
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.categoryPendencyAmount ? formatMoney(ToDineroObj(row.original.categoryPendencyAmount)) : "-"}
          </div>
        ),
      },
      {
        header: "Category Pendency (Count)",
        id: "categoryPendencyCount",
        accessorFn: (row) => parseInt(row.categoryPendencyCount) || 0,
        size: 240,
        enableColumnFilter: false,
      },
      {
        header: "Last Updated On",
        id: "lastUpdatedOn",
        accessorFn: (row) => row.lastUpdatedOn || "",
        size: 220,
        enableColumnFilter: false,
        Cell: ({ row }: any) => (
          <div className="textOverflow_hidden">
            {row.original?.lastUpdatedOn ? formatDate(row.original.lastUpdatedOn) : "-"}
          </div>
        ),
      },
    ],
    []
  );

  // Update SummaryCard to use dynamic properties
  const SummaryCard = ({ data, setFilters }: { data: any; setFilters: (filters: any[]) => void }) => {
    const { icon, bgColor, iconColor } = getSummaryCardProperties(data.title);

    return (
      <Card
        sx={{
          p: 3,
          background: "linear-gradient(to bottom, #ffffff, #f5f5f5)",
          borderRadius: 1,
          border: "1px solid #e0e0e0",
          boxShadow: "0px 0px 8px 4px rgba(0,0,0,0.02)",
          display: "flex",
          alignItems: "center",
          gap: 2,
          height: "100%",
          cursor: "pointer",
        }}
        onClick={() => {
          setFilters([
            {
              id: "resolutionStatus",
              value: [data.title],
            },
            {
              id: "dependency",
              value: [data.dependency],
            },
          ]);
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: 1,
            backgroundColor: bgColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: iconColor,
          }}
        >
          {icon}
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography
            className="body-s-bold"
            sx={{
              color: "rgba(0,0,0,0.6)",
              marginBottom: 0.5,
            }}
          >
            {data.title}
          </Typography>
          <Typography
            className="heading-m"
            sx={{
              color: "rgba(0,0,0,0.87)",
            }}
          >
            {data.amount} {`(${data.count})`}
          </Typography>
        </Box>
      </Card>
    );
  };

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const tabLabelMapping = {
    finance: "Finance",
    warehouse: "Warehouse",
    procurement: "Procurement",
    arTeam: "AR Team",
    // btpl: "BTPL",
    category: "Category",
    vendor: "Vendor",
  };

  // Function to handle Recon or Non-Recon Issues view toggle
  const handleReconOrNonReconView = (isNonReconView) => {
    // Reset states
    setIsShowVendorLevelSummary(false);
    setDisputedEntriesData([]);
    setSummaryData({});
    setFilters([]);
    setSelectedRows({});
    setActiveTab(0);

    // Set the view type
    setIsNonReconIssuesRaised(isNonReconView);

    // Refresh vendor data
    listDrEntriesVendorNames(departmentName, isNonReconView);

    // // Reset detailed summaries
    // detailedSummaryOnDependency(null);
    // detailedSummaryOnDependencyAndDocType(null);
  };

  // api integration ---------------

  useEffect(() => {
    listDrEntriesDepartment();
    listAllUsers();
    detailedSummaryOnDependency(null);
    detailedSummaryOnDependencyAndDocType(null);
  }, []);

  const listAllUsers = () => {
    useFetch(API_ENDPOINTS.FETCH_INTERNAL_PROCESS_DR_USERS.url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_INTERNAL_PROCESS_DR_USERS.failureMessage,
      thenCallBack: (response) => {
        setAllUsers(response.data.data || []);
      },
    });
  };

  const listDrEntriesDepartment = async () => {
    await useFetch(API_ENDPOINTS.FETCH_DR_ENTRIES_DEPARTMENT.url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_DR_ENTRIES_DEPARTMENT.failureMessage,
      thenCallBack: (response) => {
        setDepartmentName(response.data.data);
        departmentNameRef.current = response.data.data;
        listDrEntriesVendorNames(response.data.data);
      },
      catchCallBack: () => {},
    });
  };
  const listDrEntriesVendorNames = async (department, isNonReconView = false) => {
    setTableLoader(true);

    // For now using same API endpoint, but can be changed based on isNonReconView in future
    const apiEndpoint = isNonReconView
      ? API_ENDPOINTS.FETCH_DR_ENTRIES_PARTNER_SUMMARY_NON_RECON(role) // Future: Different endpoint for Non-Recon Issues
      : API_ENDPOINTS.FETCH_DR_ENTRIES_PARTNER_SUMMARY(role); // Current: Recon Gap Summary

    await useFetch(apiEndpoint.url, "POST", {
      failureMessage: apiEndpoint.failureMessage,
      config: {
        params: {
          department,
          // Future: Add isNonReconView parameter when backend supports it
          // isNonReconView: isNonReconView
        },
      },
      thenCallBack: (response) => {
        setTableLoader(false);
        setDrEntryVendorSummary(response.data.data);
      },
    });
  };
  const listDrEntries = async (businessPartner, isNonRecon = false) => {
    setTableLoader(true);
    const apiEndpoint = isNonRecon
      ? API_ENDPOINTS.FETCH_DR_ENTRIES_NON_RECON(role) // Future: Different endpoint for Non-Recon Issues
      : API_ENDPOINTS.FETCH_DR_ENTRIES(role); // Current: Recon Gap Entries
    await useFetch(apiEndpoint.url, "GET", {
      failureMessage: apiEndpoint.failureMessage,
      config: {
        params: {
          businessPartner,
          department: departmentNameRef.current,
          pan: panRef.current,
        },
      },
      thenCallBack: (response) => {
        setTableLoader(false);
        // Generate summary data
        const summaryFromData = generateSummaryFromData(response.data.data, isNonRecon);
        setSummaryData(summaryFromData);
        setDisputedEntriesData(response.data.data);
      },
      catchCallBack: () => {},
    });
  };

  const detailedSummaryOnDependency = async (businessPartner) => {
    await useFetch(API_ENDPOINTS.FETCH_INTERNAL_PROCESS_DR_DETAIL_SUMMARY.url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_INTERNAL_PROCESS_DR_DETAIL_SUMMARY.failureMessage,
      config: {
        params: {
          businessPartner,
          // department:departmentName,
        },
      },
      thenCallBack: (response) => {
        //   here store data in ViewDetailedSummaries in  key:"Total",
        //       const [ViewDetailedSummaries, setViewDetailedSummaries] = useState([
        // {
        //   title: "Overall Disputed Summary",
        //   key:"Total",
        //   data: []
        // },
        // structure like this push data in  key:"Total",
        //   data: []
        setViewDetailedSummaries((prev) => {
          const updatedSummaries = prev.map((summary) => {
            if (summary.key === "Total") {
              return { ...summary, data: response.data.data || [] };
            }
            return summary;
          });
          return updatedSummaries;
        });
      },
      catchCallBack: () => {},
    });
  };
  const detailedSummaryOnDependencyAndDocType = async (businessPartner) => {
    await useFetch(API_ENDPOINTS.FETCH_INTERNAL_PROCESS_DR_DETAIL_SUMMARY_DOC_TYPE.url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_INTERNAL_PROCESS_DR_DETAIL_SUMMARY_DOC_TYPE.failureMessage,
      config: {
        params: {
          businessPartner,
          // department:departmentName,
        },
      },
      thenCallBack: (response) => {
        // here also same

        //           // data is  PR/ RTV
        // :
        // []
        // Payments
        // :
        // []
        // Reversal
        // :
        // []
        // Visibility
        // :
        // []
        // here based on    key:DocType.Invoice, like this there is diff key that push

        //  that all keys present that need to push in ViewDetailedSummaries in  key:DocType.Invoice, like this there is diff key that push
        setViewDetailedSummaries((prev) => {
          const updatedSummaries = prev.map((summary) => {
            if (summary.key === DocType.Invoice) {
              return { ...summary, data: response.data.data.Invoice || [] };
            } else if (summary.key === DocType.Payment) {
              return { ...summary, data: response.data.data.Payments || [] };
            } else if (summary.key === DocType.PRRTV) {
              return { ...summary, data: response.data.data["PR/ RTV"] || [] };
            } else if (summary.key === DocType.BrandPromo) {
              return { ...summary, data: response.data.data.BrandPromo || [] };
            } else if (summary.key === DocType.Visibility) {
              return { ...summary, data: response.data.data.Visibility || [] };
            } else if (summary.key === DocType.Reversal) {
              return { ...summary, data: response.data.data.Reversal || [] };
            } else if (summary.key === DocType.InternalDocument) {
              return { ...summary, data: response.data.data.InternalDocument || [] };
            } else if (summary.key === DocType.DNCN) {
              return { ...summary, data: response.data.data.DNCN || [] };
            }
            return summary;
          });
          return updatedSummaries;
        });
      },
      catchCallBack: () => {},
    });
  };

  // Function to download Excel file
  const handleDownloadExcel = () => {
    setIsDownloading(true);
    const apiEndpoint = isNonReconIssuesRaised
      ? API_ENDPOINTS.FETCH_DR_ENTRIES_REPORT_NON_RECON
      : API_ENDPOINTS.FETCH_DR_ENTRIES_REPORT;
    useFetch(apiEndpoint(role).url, "GET", {
      failureMessage: apiEndpoint(role).failureMessage,
      config: {
        params: {
          businessPartner: partnerNameRef.current,
          department: departmentNameRef.current,
          pan: panRef.current,
        },
      },
      thenCallBack: (response) => {
        const filename = isNonReconIssuesRaised ? `Non recon issues list.xlsx` : `Disputed_Entries_Report.xlsx`;
        const excelData = Buffer.from(response.data.data?.excel ?? response.data.data, "base64");
        const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob = new Blob([excelData], { type: fileType });
        saveAs(blob, filename);
        setIsDownloading(false);
      },
      catchCallBack: () => {
        setIsDownloading(false);
      },
    });
  };

  const handleDownloadAllExcel = () => {
    setIsDownloadingAll(true);

    if (isNonReconIssuesRaised) {
      const allReportEndpoint = API_ENDPOINTS.FETCH_DR_ENTRIES_REPORT_ALL_NON_RECON(role);
      useFetch(allReportEndpoint.url, "GET", {
        failureMessage: allReportEndpoint.failureMessage,
        config: {
          params: {
            department: departmentNameRef.current,
          },
        },
        thenCallBack: (response) => {
          const rawData = response.data.data?.excel ?? response.data.data;
          const excelData = Buffer.from(rawData, "base64");
          const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const blob = new Blob([excelData], { type: fileType });
          const filename = response.data.data.filename || `NonRecon_Dispute_All_Vendors_Report.xlsx`;
          saveAs(blob, filename);
          setIsDownloadingAll(false);
        },
        catchCallBack: () => {
          setIsDownloadingAll(false);
        },
      });
      return;
    }

    // DR report/all now returns the partner-level summary as a raw .xlsx binary (not base64 JSON)
    const allReportEndpoint = API_ENDPOINTS.FETCH_DR_ENTRIES_REPORT_ALL(role);
    useFetch(allReportEndpoint.url, "GET", {
      failureMessage: allReportEndpoint.failureMessage,
      config: {
        params: {
          department: departmentNameRef.current,
        },
        responseType: "blob",
      },
      thenCallBack: (response) => {
        const disposition = response.headers["content-disposition"] ?? "";
        const filename = /filename="?([^";]+)"?/.exec(disposition)?.[1] || `Recon_Gap_All_Vendors_Report.xlsx`;
        saveAs(response.data as Blob, filename);
        setIsDownloadingAll(false);
      },
      catchCallBack: () => {
        setIsDownloadingAll(false);
      },
    });
  };
  // ------------------------- -

  return (
    <LoggedInSkeleton topBarButtons={getReconTopBarButtons(" ", actor.name, location?.state?.openCollapseObj, actor)}>
      {showDetailedSummary ? (
        <Box sx={{ p: 4, bgcolor: "#ffffff", borderRadius: 1 }}>
          {/* Header */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography
                className="heading-m"
                sx={{
                  color: "rgba(0,0,0,0.87)",
                  letterSpacing: "0.15px",
                }}
              >
                View Detailed Summaries
              </Typography>
            </Box>
            <CustomButton
              size="medium"
              colorToken="violet"
              variant="outlined"
              startIcon={<ArrowBack />}
              onClick={() => {
                setShowDetailedSummary(false);
              }}
            >
              Back
            </CustomButton>
          </Box>

          {/* Static Non-Recon Summary Table (shown above dynamic tables) */}
          {isNonReconIssuesRaised && <NonReconDetailedSummaryTable />}

          {/* Dynamic Summary Tables */}
          {(isNonReconIssuesRaised ? nonReconViewDetailedSummaries : viewDetailedSummaries)
            .filter((item) => item.data.length > 0)
            .map((summaryConfig) => (
              <DetailedSummariesTable
                key={summaryConfig.title}
                title={summaryConfig.title}
                data={summaryConfig.data} // Use data from configuration
              />
            ))}

          {/* Department-wise progress table */}
          {isNonReconIssuesRaised && <NonReconProgressTable />}
        </Box>
      ) : (
        <Box sx={{ p: 4, bgcolor: "#ffffff", borderRadius: 1 }}>
          {/* Header */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              {isShowVendorLevelSummary && (
                <IconButton
                  size="small"
                  onClick={() => {
                    setIsShowVendorLevelSummary(false);
                    setDisputedEntriesData([]);
                    setSummaryData({});
                    setFilters([]);
                    {
                      !isNonReconIssuesRaised && detailedSummaryOnDependency(null);
                      detailedSummaryOnDependencyAndDocType(null);
                    }
                  }}
                  sx={{
                    color: "#531c4c",
                    "&:hover": {
                      backgroundColor: "rgba(83, 28, 76, 0.04)",
                    },
                  }}
                >
                  <Tooltip title="Back to Summary">
                    <ArrowBack />
                  </Tooltip>
                </IconButton>
              )}
              <Typography
                className="heading-m"
                sx={{
                  color: "rgba(0,0,0,0.87)",
                  letterSpacing: "0.15px",
                }}
              >
                {isNonReconIssuesRaised ? "Non-Recon Issues Raised" : "Recon Gap Summary"}
              </Typography>
              {/* {!isNonReconIssuesRaised && ( */}
              <CustomButton
                size="small"
                colorToken="violet"
                variant="outlined"
                endIcon={<OpenInNewIcon />}
                onClick={() => {
                  setShowDetailedSummary(true);
                }}
              >
                View Detailed Summaries
              </CustomButton>
              {/* )} */}
            </Box>
            {!isShowVendorLevelSummary && (
              <Box>
                {!isNonReconIssuesRaised ? (
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <Tooltip title="Download All Vendors Report">
                      <span>
                        <IconButton
                          size="small"
                          onClick={handleDownloadAllExcel}
                          disabled={isDownloadingAll}
                          sx={{
                            color: "#531c4c",
                            "&:hover": { backgroundColor: "rgba(83, 28, 76, 0.04)" },
                          }}
                        >
                          {isDownloadingAll ? <CircularProgress size={24} color="inherit" /> : <GetAppIcon />}
                        </IconButton>
                      </span>
                    </Tooltip>
                    <CustomButton
                      size="medium"
                      color="error"
                      variant="outlined"
                      endIcon={<LogoutIcon />}
                      onClick={() => handleReconOrNonReconView(true)}
                    >
                      Non-Recon Issues Raised
                    </CustomButton>
                  </Box>
                ) : (
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <Tooltip title="Download All Vendors Report">
                      <span>
                        <IconButton
                          size="small"
                          onClick={handleDownloadAllExcel}
                          disabled={isDownloadingAll}
                          sx={{
                            color: "#531c4c",
                            "&:hover": { backgroundColor: "rgba(83, 28, 76, 0.04)" },
                          }}
                        >
                          {isDownloadingAll ? <CircularProgress size={24} color="inherit" /> : <GetAppIcon />}
                        </IconButton>
                      </span>
                    </Tooltip>
                    <CustomButton
                      size="medium"
                      colorToken="violet"
                      variant="outlined"
                      endIcon={<LogoutIcon />}
                      onClick={() => handleReconOrNonReconView(false)}
                    >
                      Recon Gap Summary
                    </CustomButton>
                  </Box>
                )}
              </Box>
            )}
            {isShowVendorLevelSummary && (
              <Box sx={{ display: "flex", gap: 1 }}>
                {!isNonReconIssuesRaised && (
                  <CustomButton
                    size="medium"
                    color="error"
                    variant="outlined"
                    startIcon={<InfoOutlined />}
                    onClick={() => {
                      const existingFilterIndex = filters.findIndex((f) => f.id === "vendorDisputeStatus");
                      let updatedFilters;

                      if (existingFilterIndex !== -1) {
                        // Replace existing vendorDisputeStatus filter
                        updatedFilters = [...filters];
                        updatedFilters[existingFilterIndex] = {
                          id: "vendorDisputeStatus",
                          value: ["Dispute Raised"],
                        };
                      } else {
                        // Add new filter if it doesn't exist
                        updatedFilters = [
                          ...filters,
                          {
                            id: "vendorDisputeStatus",
                            value: ["Dispute Raised"],
                          },
                        ];
                      }

                      setFilters(updatedFilters);
                    }}
                  >
                    View Disputes
                  </CustomButton>
                )}
                <CustomButton
                  size="medium"
                  colorToken="violet"
                  variant="outlined"
                  startIcon={<FilterListIcon />}
                  onClick={() => {
                    isNonReconIssuesRaised
                      ? setOpenNonReconFilterOfDisputedEntries(true)
                      : setOpenFilterOfDisputedEntries(true);
                  }}
                >
                  Filter
                </CustomButton>
              </Box>
            )}
          </Box>
          {isShowVendorLevelSummary ? (
            <>
              {/* Filters Bar */}
              {filters?.some((f) =>
                Array.isArray(f.value)
                  ? f.value.some((v) => v !== null && v !== undefined && v !== "")
                  : f.value !== null && f.value !== undefined && f.value !== ""
              ) && <RejectedInvoicesFiltersBars filters={filters} setFilters={setFilters} />}

              {/* Summary Cards */}
              <Box sx={{ mb: 4 }}>
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  sx={{
                    minHeight: 44,
                    "& .MuiTabs-indicator": {
                      backgroundColor: "#531c4c",
                    },
                    "& .MuiChip-root": {
                      color: "#fff",
                      bgcolor: "#0009",
                      px: "6.5px",
                      py: 0,
                    },
                    "& .Mui-selected": {
                      color: "#531c4c !important",
                      "& .MuiChip-root": {
                        bgcolor: "#531c4c",
                      },
                    },
                  }}
                >
                  {Object.keys(summaryData).map((key, index) => (
                    <Tab key={index} label={tabLabelMapping[key]} sx={{ textTransform: "none", minHeight: "auto" }} />
                  ))}
                </Tabs>

                {Object.keys(summaryData).map(
                  (key, index) =>
                    activeTab === index && (
                      <Box key={index} sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 2, mt: 2 }}>
                        {(summaryData[key] || []).map((data, dataIndex) => (
                          <SummaryCard key={dataIndex} data={data} setFilters={setFilters} />
                        ))}
                      </Box>
                    )
                )}
              </Box>

              <Box sx={{ mb: 3 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                  <Typography
                    className="heading-m"
                    sx={{
                      color: "rgba(0,0,0,0.87)",
                    }}
                  >
                    Account Overview
                  </Typography>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    {/* <CustomButton
                                size="medium"
                                colorToken="violet"
                                variant="contained"
                                startIcon={<FileUploadIcon />}
                            >
                                Upload Documents
                            </CustomButton> */}
                    {!isNonReconIssuesRaised && (
                      <CustomButton
                        size="medium"
                        colorToken="violet"
                        variant="contained"
                        onClick={() => setOpenBulkActionModal(true)}
                        disabled={Object.keys(selectedRows).filter((key) => selectedRows[key]).length === 0}
                      >
                        Bulk Actions
                      </CustomButton>
                    )}
                    {isNonReconIssuesRaised && (
                      <CustomButton
                        size="medium"
                        colorToken="violet"
                        variant="contained"
                        onClick={() => setOpenNonReconBulkActionModal(true)}
                        disabled={Object.keys(selectedRows).filter((key) => selectedRows[key]).length === 0}
                      >
                        Bulk Actions
                      </CustomButton>
                    )}
                    <IconButton
                      size="small"
                      onClick={handleDownloadExcel}
                      sx={{
                        color: "#531c4c",
                        "&:hover": {
                          backgroundColor: "rgba(83, 28, 76, 0.04)",
                        },
                      }}
                      disabled={isDownloading}
                    >
                      <Tooltip title="Download Excel">
                        {isDownloading ? (
                          <CircularProgress size={24} color="inherit" /> // Show loading icon
                        ) : (
                          <GetAppIcon />
                        )}
                      </Tooltip>
                    </IconButton>
                  </Box>
                </Box>

                {/* ReactTable */}
                <ReactTable
                  columns={isNonReconIssuesRaised ? columnDefinitionNonRecon : columnDefinition}
                  rows={disputedEntriesData.length > 0 ? disputedEntriesData : []}
                  loading={tableLoader}
                  enableColumnResizing={true}
                  enableRowSelection={true}
                  enableColumnPinning={true}
                  onColumnFiltersChange={setFilters}
                  onRowSelectionChange={setSelectedRows}
                  additionalState={{
                    columnFilters: filters,
                    rowSelection: selectedRows,
                    columnPinning: {
                      right: ["actions"],
                    },
                  }}
                  enableGlobalFilter={true}
                  internalActionsOrder={["filterToggle", "showHideColumns", "fullScreenToggle"]}
                  initialState={{
                    showColumnFilters: true,
                    columnPinning: {
                      left: ["resolutionStatus"],
                      right: ["actions"],
                    },
                  }}
                  setSelectedRow={setSelectedRows}
                />
              </Box>
            </>
          ) : (
            <>
              <Box>
                <ReactTable
                  columns={isNonReconIssuesRaised ? columnDefinitionSummaryNonRecon : columnDefinitionSummary}
                  rows={drEntryVendorSummary || []}
                  loading={tableLoader}
                  enableColumnResizing={true}
                  enableRowSelection={false}
                  enableColumnPinning={true}
                  additionalState={{
                    columnPinning: {
                      left: ["partnerName"],
                    },
                  }}
                  // getRowId={(row) => row.id}
                  enableGlobalFilter={true}
                  internalActionsOrder={["filterToggle", "showHideColumns", "fullScreenToggle"]}
                  initialState={{
                    showColumnFilters: true,
                    columnPinning: {
                      left: ["partnerName"],
                    },
                  }}
                />
              </Box>
            </>
          )}
        </Box>
      )}
      {openRemarksModal && (
        <RemarksDisputedEntries
          selectedRowOfDisputedEntryForModal={selectedRowOfDisputedEntryForModal}
          openRemarksModal={openRemarksModal}
          setOpenRemarksModal={setOpenRemarksModal}
        />
      )}
      {openNonReconRemarksModal && (
        <NonReconRemarksDisputedEntries
          selectedRowOfDisputedEntryForModal={selectedRowOfDisputedEntryForModal}
          openRemarksModal={openNonReconRemarksModal}
          setOpenRemarksModal={setOpenNonReconRemarksModal}
        />
      )}
      {openViewHistoryModal && (
        <ViewHistoryDisputedEntries
          selectedRowOfDisputedEntryForModal={selectedRowOfDisputedEntryForModal}
          openViewHistoryModal={openViewHistoryModal}
          setOpenViewHistoryModal={setOpenViewHistoryModal}
        />
      )}
      {openNonReconViewHistoryModal && (
        <NonReconViewHistoryDisputedEntries
          selectedRowOfDisputedEntryForModal={selectedRowOfDisputedEntryForModal}
          openViewHistoryModal={openNonReconViewHistoryModal}
          setOpenViewHistoryModal={setOpenNonReconViewHistoryModal}
        />
      )}
      {openEntryDetailsModal && (
        <EntryDetailsDisputedEntries
          selectedRowOfDisputedEntryForModal={selectedRowOfDisputedEntryForModal}
          openEntryDetailsModal={openEntryDetailsModal}
          setOpenEntryDetailsModal={setOpenEntryDetailsModal}
        />
      )}

      {openTakeActionModal && (
        <TakeActionDisputedEntries
          selectedRowOfDisputedEntryForModal={selectedRowOfDisputedEntryForModal}
          openTakeActionModal={openTakeActionModal}
          setOpenTakeActionModal={setOpenTakeActionModal}
          selectedRowIndex={selectedRowIndex}
          disputedEntriesData={disputedEntriesData}
          setDisputedEntriesData={setDisputedEntriesData}
          setSummaryData={setSummaryData}
          generateSummaryFromData={generateSummaryFromData}
          departmentName={departmentName}
          allUsers={allUsers}
          role={role}
        />
      )}
      {openNonReconTakeActionModal && (
        <NonReconTakeActionDisputedEntries
          selectedRowOfDisputedEntryForModal={selectedRowOfDisputedEntryForModal}
          openTakeActionModal={openNonReconTakeActionModal}
          setOpenTakeActionModal={setOpenNonReconTakeActionModal}
          selectedRowIndex={selectedRowIndex}
          disputedEntriesData={disputedEntriesData}
          setDisputedEntriesData={setDisputedEntriesData}
          setSummaryData={setSummaryData}
          generateSummaryFromData={generateSummaryFromData}
          departmentName={departmentName}
          allUsers={allUsers}
          role={role}
        />
      )}
      {openBulkActionModal && (
        <BulkActionDisputedEntries
          selectedRows={Object.keys(selectedRows)
            .filter((key) => selectedRows[key])
            .map((index) => disputedEntriesData[parseInt(index)])}
          openBulkActionModal={openBulkActionModal}
          setOpenBulkActionModal={setOpenBulkActionModal}
          allUsers={allUsers}
          role={role}
          departmentName={departmentName}
          setSelectedRows={setSelectedRows}
          listDrEntries={listDrEntries}
          partnerNameRef={partnerNameRef}
        />
      )}
      {openNonReconBulkActionModal && (
        <NonReconBulkActionDisputedEntries
          selectedRows={Object.keys(selectedRows)
            .filter((key) => selectedRows[key])
            .map((index) => disputedEntriesData[parseInt(index)])}
          openBulkActionModal={openNonReconBulkActionModal}
          setOpenBulkActionModal={setOpenNonReconBulkActionModal}
          allUsers={allUsers}
          role={role}
          departmentName={departmentName}
          setSelectedRows={setSelectedRows}
          listDrEntries={listDrEntries}
          partnerNameRef={partnerNameRef}
        />
      )}
      {openFilterOfDisputedEntries && (
        <FilterOfDisputedEntries
          openFilterOfDisputedEntries={openFilterOfDisputedEntries}
          setOpenFilterOfDisputedEntries={setOpenFilterOfDisputedEntries}
          filters={filters}
          setFilters={setFilters}
          data={disputedEntriesData}
        />
      )}
      {openNonReconFilterOfDisputedEntries && (
        <NonReconFilterOfDisputedEntries
          openFilterOfDisputedEntries={openNonReconFilterOfDisputedEntries}
          setOpenFilterOfDisputedEntries={setOpenNonReconFilterOfDisputedEntries}
          filters={filters}
          setFilters={setFilters}
          data={disputedEntriesData}
        />
      )}
    </LoggedInSkeleton>
  );
};

export default DisputedEntries;
